export default "__VITE_ASSET__avhmnOf2__"